import MailOutline from "@mui/icons-material/MailOutline";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo, type ReactElement } from "react";
import { useLocation } from "wouter";
import { navLinks } from "../../constants";
import { MdaiLink } from "../MdaiLink";

const tabs =
  navLinks.find((group) => group.groupName === "What's New")?.links ?? [];

export function TabsTilesWrapper({ children }: { children: ReactElement }) {
  const [location, navigate] = useLocation();
  const handleTabChange = useCallback(
    (_e: React.SyntheticEvent, tab: string) => {
      navigate(tab);
    },
    [navigate],
  );

  const tabValue = useMemo(() => {
    const tab = location.split("/")[1];

    return `/${tab}`;
  }, [location]);

  return (
    <Stack gap={3}>
      <Typography variant="h2">What's New</Typography>
      <Stack direction={{ sm: "column-reverse", md: "row" }}>
        <Tabs
          sx={{ flex: "1 1 auto " }}
          value={tabValue}
          onChange={handleTabChange}
        >
          {tabs.map(({ label, href }) => (
            <Tab
              key={label}
              label={label}
              value={href}
              aria-controls={`${href}-control-tab`}
            />
          ))}
        </Tabs>
        <Stack
          direction={{ sm: "column", md: "row" }}
          sx={{
            alignItems: "center",
            gap: 3,
          }}
        >
          <MdaiLink
            type="button"
            size="small"
            variant="contained"
            buttonColor="inherit"
            href="mailto:pr@mydecisive.ai"
            style={{
              color: "rgba(0, 0, 0, 0.87) !important",
            }}
            width={{ sm: "100%", md: "auto", lg: "auto" }}
            label={
              <Stack direction={"row"} alignItems="center" gap={1}>
                <MailOutline /> PR@MYDECISIVE.AI
              </Stack>
            }
          />
          <Typography>
            Download our{" "}
            <Link href="/mdai-media-kit.zip" download="MdaiMediaKit">
              media kit
            </Link>
          </Typography>
        </Stack>
      </Stack>
      {children}
    </Stack>
  );
}
